/**
 * Generated runtime TestId mirror for frontend/src/components/restriction-rules/DetectionHistoryCard.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const DetectionHistoryCardTestIds = {
  cardTitleDetectionHistory: "card-title-detection-history",
  detectionEmpty: "detection-empty",
  detectionError: "detection-error",
  detectionHistoryCard: "detection-history-card",
  detectionLoading: "detection-loading",
  linkViewAllDetections: "link-view-all-detections",
  detectionErrorLink: (entry_id: string) => `detection-error-link-${entry_id}`,
  detectionErrorLinkPrefix: () => "detection-error-link-" as TestIdPrefix,
  detectionEvaluated: (entry_id: string) => `detection-evaluated-${entry_id}`,
  detectionEvaluatedPrefix: () => "detection-evaluated-" as TestIdPrefix,
  detectionFound: (entry_id: string) => `detection-found-${entry_id}`,
  detectionFoundPrefix: () => "detection-found-" as TestIdPrefix,
  detectionResolved: (entry_id: string) => `detection-resolved-${entry_id}`,
  detectionResolvedPrefix: () => "detection-resolved-" as TestIdPrefix,
  detectionRow: (entry_id: string) => `detection-row-${entry_id}`,
  detectionRowPrefix: () => "detection-row-" as TestIdPrefix,
  detectionStatus: (entry_id: string) => `detection-status-${entry_id}`,
  detectionStatusPrefix: () => "detection-status-" as TestIdPrefix
} as const;
